<template lang="pug" functional>
	.loader
		.loader-spinner
</template>

<script>
export default {
  name: "MatrixLoader"
};
</script>

<style lang="scss" scoped>
.loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
	.wizard & {
		position: static;
	}
}

.loader-spinner,
.loader-spinner:before,
.loader-spinner:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation: load7 1.8s infinite ease-in-out;
}
.loader-spinner {
  color: $cobalt;
  font-size: 10px;
  margin: 80px auto;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation-delay: -0.16s;
	.wizard & {
		margin: 10rem auto;
	}
}
.loader-spinner:before,
.loader-spinner:after {
  content: '';
  position: absolute;
  top: 0;
}
.loader-spinner:before {
  left: -3.5em;
  animation-delay: -0.32s;
}
.loader-spinner:after {
  left: 3.5em;
}
@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
</style>